<template>
  <div class="container">
    <b-modal
      :model-value="modInfoUser"
      :no-close-on-backdrop="true"
      hide-footer
      hide-header-close
      centered
      :title="labels.title"
      header-class="reset-modal-header"
      title-class="reset-modal-title"
      body-class="reset-modal-body"
      class="reset-password-dialog info-user-dialog"
    >
      <div class="uniform-modal-body">
        <!-- Caja informativa -->
        <div class="password-policy-box mb-4">
          <div class="password-policy-title">{{ labels.infoTitle }}</div>
          <div class="password-policy-subtitle">{{ labels.infoText }}</div>
        </div>

        <!-- Información del usuario -->
        <div class="user-info-container">
          <b-row class="info-row">
            <b-col md="4" class="info-label-col">
              <h5 class="info-label">{{ labels.name }}</h5>
            </b-col>
            <b-col md="8" class="info-value-col">
              <h6 class="info-value">{{ dataUser[0]?.nombre || dataUser[0]?.name }}</h6>
            </b-col>
          </b-row>

          <b-row class="info-row">
            <b-col md="4" class="info-label-col">
              <h5 class="info-label">{{ labels.cedula }}</h5>
            </b-col>
            <b-col md="8" class="info-value-col">
              <h6 class="info-value">{{ dataUser[0]?.cedula }}</h6>
            </b-col>
          </b-row>

          <b-row class="info-row">
            <b-col md="4" class="info-label-col">
              <h5 class="info-label">{{ labels.correo }}</h5>
            </b-col>
            <b-col md="8" class="info-value-col">
              <h6 class="info-value">{{ dataUser[0]?.email }}</h6>
            </b-col>
          </b-row>

          <b-row class="info-row">
            <b-col md="4" class="info-label-col">
              <h5 class="info-label">{{ labels.phone }}</h5>
            </b-col>
            <b-col md="8" class="info-value-col">
              <h6 class="info-value">{{ dataUser[0]?.telefono }}</h6>
            </b-col>
          </b-row>

          <b-row class="info-row">
            <b-col md="4" class="info-label-col">
              <h5 class="info-label">{{ labels.rol }}</h5>
            </b-col>
            <b-col md="8" class="info-value-col">
              <h6 class="info-value">{{ nombreRol() }}</h6>
            </b-col>
          </b-row>
        </div>

        <!-- Botón cerrar -->
        <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
          <b-button class="btn-secondary" @click="cierraModal">{{ labels.close }}</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'infoUser',
  props: ['modInfoUser', 'dataRole', 'dataUser'],
  data: () => ({}),
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          title: "Información del Usuario",
          save: "Guardar",
          close: "Cerrar",
          name: "Nombre",
          cedula: "Cédula",
          correo: "Correo electrónico",
          phone: "Teléfono",
          rol: "Rol",
          infoTitle: "Datos del usuario",
          infoText: "Consulta la información completa del usuario."
        }
      } else {
        return {
          title: "User information",
          save: "Save",
          close: "Close",
          name: "Name",
          cedula: "Identification number",
          correo: "Email",
          phone: "Phone",
          rol: "Role",
          infoTitle: "User information",
          infoText: "View complete user information."
        }
      }
    }
  },
  methods: {
    cierraModal() {
      this.$emit('cierraModal', false)
    },
    nombreRol() {
      let nameRole = ''
      this.dataUser.forEach((user) => {
        this.dataRole.forEach((rol) => {
          if (rol.id == user.id_rol) {
            nameRole = rol.nombre
          }
        })
      })
      return nameRole
    }
  }
}
</script>